import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import history from '../../config/history'
import Icon from '../Icon/Icon'
import './Panel.scss'

const Panel = ({
  title,
  icon,
  children,
  linkTo,
  hasChildren,
  isLinkEnabled,
  onClick,
}) => {
  const active = linkTo === history.location.pathname
  return (
    <section className={`Panel${active ? ' -active' : ''}`} onClick={onClick}>
      <header className={`Panel__header ${!hasChildren ? '-allRound' : ''}`}>
        <h3>
          <Icon name={icon} className="Panel__titleIcon" />
          {title}
          {!active && <Icon name="arrow-right" className="Panel__goToIcon" />}
        </h3>
        {!active && isLinkEnabled && <Link exact="true" to={linkTo} />}
      </header>
      {hasChildren && <div className="Panel__body">{children}</div>}
    </section>
  )
}

Panel.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  linkTo: PropTypes.string,
  children: PropTypes.object,
  hasChildren: PropTypes.bool,
  isLinkEnabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default Panel
